import { SVCurrencyInput, SVAutocomplete } from '@/components/core';
import { SelectOption } from '@/types/inputs';
import { Card, Grid, Typography } from '@mui/material';

type BankAccountApplicationInitialDepositProps = {
  externalAccountsForSelection: SelectOption[];
};

export default function BankAccountApplicationInitialDeposit({
  externalAccountsForSelection,
}: BankAccountApplicationInitialDepositProps) {
  if (!externalAccountsForSelection.length) {
    return null;
  }

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Initial Deposit
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVAutocomplete
            name="externalAccountDepositId"
            label="Withdrawal Money From"
            options={externalAccountsForSelection}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVCurrencyInput
            name="depositAmount"
            label="Initial Deposit Amount"
            rules={{ required: false }}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
